import { gql } from '@apollo/client';
import { ProductBasicDetailsFragment } from 'link-state/modular-pdp/queries';
import { PRODUCT_GRID_FRAGMENT_LITE } from 'mocks/queries';

export const GET_MODULAR_SOFA_BUNDLE = gql`
  query getModularSofaBundle(
    $slug: String
    $zipCode: String
    $stateCode: String
    $regionId: String
  ) {
    modularBundle: getModularSofaBundle(slug: $slug) {
      modular_parent {
        ...ProductBasicDetailsFragment
      }
      products {
        sku
        difficulty
        variation_photos
        hero_images {
          sort_order
          img {
            url
            cropData
          }
          upholstery_name
          upholstery_type
        }
        family {
          name
        }
        ...ProductGridFragmentLite
      }
      preConfiguredProducts {
        hero_images {
          sort_order
          img {
            url
            cropData
          }
          upholstery_name
          upholstery_type
        }
        customer_photos_min {
          photos {
            id
            url
            full_name
            comment
          }
          totalPhotos
        }
        customer_reviews {
          reviews {
            id
            title
            comment
            date
            full_name
            location
            rate
          }
          totalReviews
          averageRating
        }
        ...ProductGridFragmentLite
      }
      totalProductsCount
    }
  }
  ${ProductBasicDetailsFragment}
  ${PRODUCT_GRID_FRAGMENT_LITE}
`;
